module.exports = __webpack_public_path__ + "static/img/14.08dc3bf5.png";